import { Card } from 'components/ui/card'

const IMAGE_ROOT = '/images/vendors/centercheck'

const OBSERVATIONS = [
	{ image: 'cc_observation_1.png', alt: 'Card sales trend with nationwide and state rank' },
	{ image: 'cc_observation_2.png', alt: 'Shopper demographics' },
	{ image: 'cc_observation_3.png', alt: 'Trade area population and demographics on a map' },
	{ image: 'cc_observation_4.png', alt: 'Time of sales activity chart' },
]

/**
 * A mockup of the CenterCheck integration, laid out like the Sites page: a
 * scrolling column of cards beside the map. Every panel is a picture, so nothing
 * here describes this evaluation, and the page says so.
 *
 * The cards get 1/5 of the width rather than the 1/6 they have on Sites, where
 * these charts would be too small to read.
 */
const CenterCheckResource = () => (
	<div className="space-y-4">
		<div>
			<h3 className="text-lg font-semibold text-gray-900">CenterCheck</h3>
			<p className="text-sm text-gray-500">Preview with sample data</p>
		</div>

		<div className="grid grid-cols-[1fr_4fr] gap-4 h-[calc(100vh-330px)] min-h-[500px]">
			<div className="overflow-y-auto space-y-2 pr-1">
				{OBSERVATIONS.map(({ image, alt }) => (
					<Card key={image} className="overflow-hidden">
						<img src={`${IMAGE_ROOT}/${image}`} alt={alt} className="h-auto w-full" />
					</Card>
				))}
			</div>

			<div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
				<img
					src={`${IMAGE_ROOT}/cc_base_map.png`}
					alt="CenterCheck map of the Los Angeles area"
					className="h-full w-full object-cover object-left-top"
				/>
			</div>
		</div>
	</div>
)

export default CenterCheckResource
